export default "__VITE_ASSET__DMvP2WFh__"